import { MprcContainer } from "components/MprcContainer";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import { MprcPrompt } from "components/MprcPrompt";
import React, { useState } from "react";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    actions: React.ReactNode[];
    recordChanged: boolean;
    onClose: (reload?: boolean) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Header de Gerencimento de Inscrições.
 * @param props
 */
export const EnrollmentManagerHeader: React.FC<IProps> = (props) => {

    const { actions, onClose } = props;
    const [showLostChange, setShowLostChange] = useState<boolean>(false);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer>
            <MprcFormBarHeader actions={actions} />

            <MprcPrompt
                open={showLostChange}
                onCancel={() => setShowLostChange(false)}
                onConfirm={onClose} />

        </MprcContainer>
    );
};
